import dynamic from "next/dynamic";
import { Button, IconFa, Text } from "@cruk/cruk-react-components";
import { useOneTrustConsent } from "@fwa/src/hooks/useOneTrustConsent";
import { faVideoSlash } from "@fortawesome/free-solid-svg-icons";

const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export const VideoResponsive = ({
  videoUrl,
  editInPlaceMode = false,
  onPlay,
  onError,
  onReady,
}: {
  videoUrl: string;
  onPlay?: () => void;
  onError?: () => void;
  onReady?: () => void;
  editInPlaceMode?: boolean;
}) => {
  const { isLoading: oneTrustLoading, targetingAllowed } = useOneTrustConsent();
  const canShowVideo = !oneTrustLoading && targetingAllowed;

  return (
    <>
      {!canShowVideo ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
            aspectRatio: "16 / 9",
            padding: "var(--spacing-m, 2rem)",
            gap: "var(--spacing-m, 2rem)",
            backgroundColor: "var(--clr-background-mid, #e6e6e6)",
          }}
        >
          <Text textAlign="center">
            {`Video content requires "Targeting" cookie consent`}
          </Text>
          <IconFa faIcon={faVideoSlash} size="m" />
          {!editInPlaceMode ? (
            <Button
              onClick={() => {
                if (
                  typeof window !== "undefined" &&
                  window?.OneTrust?.ToggleInfoDisplay
                ) {
                  window.OneTrust.ToggleInfoDisplay();
                }
              }}
            >
              Update cookie preferences
            </Button>
          ) : (
            <Button as="div" appearance="primary">
              Video settings
            </Button>
          )}
        </div>
      ) : (
        <ReactPlayer
          style={{ aspectRatio: "16 / 9" }}
          url={videoUrl || ""}
          height="auto"
          width="100%"
          onPlay={() => (onPlay ? onPlay() : null)}
          onError={() => (onError ? onError() : null)}
          onReady={() => (onReady ? onReady() : null)}
          controls
          config={{
            youtube: {
              playerVars: {
                origin: "https://www.youtube.com",
              },
            },
          }}
        />
      )}
    </>
  );
};

export default VideoResponsive;
